import React, { Suspense } from 'react';
import {withRouter} from 'react-router-dom';
import Announcement from './components/Announcement';
import { useSelector } from 'react-redux';
import MenuLayout from '../../layouts/MenuLayout';
import classNames from 'classnames';
import Menu from './tabs/Menu';
import Loader from '../../components/loaders/Loader';
import { tabs } from '../../store/actions/restaurant.actions';
import { DownloadAppSmall } from '../../components/DownloadAppSmall';
import { useRestaurant } from '../../contexts/restaurant.context';
import { CheckoutPreset } from '../../components/checkout-preset';
import { orderMethods } from '../../constants/checkout';
import { AdBagsWebsite } from '../../components/AdBagsWebsite';

const About = React.lazy(() => import('./tabs/About'));
const Review = React.lazy(() => import('./tabs/Review'));

function Restaurant() {
    const restaurant = useRestaurant();
    
    const currentTab = useSelector(state => state.restaurant.activeTab);
    
    const isShowDownloadAppButtons = !!restaurant ? !restaurant.is_hide_download_app_link : true;
    const isShowLastHourTreatsLinkButtons = !!restaurant ? !restaurant.is_hide_last_hour_treats_link : true;
    
    const isShowCheckoutPresetWizard = !(restaurant?.delivery_method.length === 1
        && restaurant?.delivery_method.includes(orderMethods.pickup));
    
    return (
        <MenuLayout>
            {isShowCheckoutPresetWizard && (
                <CheckoutPreset />
            )}
            
            <div id="restaurantInfo">
                {isShowLastHourTreatsLinkButtons && <AdBagsWebsite />}
                
                {isShowDownloadAppButtons && (
                    <DownloadAppSmall className="mb-4 mt-3" />
                )}
                
                {/*<Header/>*/}
                <Announcement />
                
                <div className="restaurant-body">
                    <div className="tab-content">
                        <div className={classNames('tab-pane fade show active', {
                            'restaurant-menu': currentTab === tabs.menu,
                            'restaurant-about': currentTab === tabs.about,
                            'restaurant-reviews': currentTab === tabs.review
                        })} role="tabpanel">
                            <Suspense fallback={<Loader />}>
                                {currentTab === tabs.menu && <Menu />}
                                {currentTab === tabs.about && <About />}
                                {currentTab === tabs.review && <Review />}
                            </Suspense>
                        </div>
                    </div>
                </div>
            </div>
        </MenuLayout>
    );
}

export default withRouter(Restaurant);